module.exports = __webpack_public_path__ + "cd579a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/dl_appstore@2x.png
// module id = 1028
// module chunks = 0